import { Navigate, useLocation } from "react-router-dom"
import { useSystemMode } from "../context/useSystemModeContext"
import { PATH_MAP } from "../configuration/PathMap"
import { JSX } from "react"
import { getDateRangeSearch } from "../utils/dateRangeSearchParams"

const KitchenOnlyRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const { systemMode } = useSystemMode()
  const location = useLocation()

  if (systemMode !== "KITCHEN") {
    return <Navigate to={`${PATH_MAP.COMMANDS_PAGE}${getDateRangeSearch(window.location.search || location.search)}`} replace />
  }

  return children
}

export default KitchenOnlyRoute
